import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Inject,
  PLATFORM_ID, QueryList,
  ViewChild,
  ViewChildren
} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {Meta, Title} from '@angular/platform-browser';
import {filter} from 'rxjs';
import {isPlatformBrowser, NgForOf, NgIf} from '@angular/common';
import {BilletsService} from '../../services/billets.service';
import {SettingsComponent} from '../../components/settings/settings.component';
import {cookiesService} from '../../services/cookies.service';
import {SettingsService} from '../../services/settings.service';

@Component({
  selector: 'biletthemedetails-page',
  templateUrl: './biletthemedetails.component.html',
  imports: [
    NgForOf,
    NgIf,
    SettingsComponent,

  ],
  styleUrl: './biletthemedetails.component.less'
})
export class BiletThemeDetailsPageComponent {
  @ViewChildren('billet')
  billets!: QueryList<ElementRef<HTMLElement>>;

  @ViewChild('scrollContainerBillets')
  scrollContainerBillets!: ElementRef<HTMLDivElement>;

  theme_index = 0

  question_index: number = 0

  open_explanation = false

  check_theme:any

  scroll_billets: any = {
    all_billets: false,
    isDragging: false,
    startX: 0,
    scrollLeft: 0,
    moved: false,
    element: null as HTMLElement | null,
    isEnd: false
  }

  my_answer_themes: any = {}
  questionsMap = new Map<number, any>();
  constructor(public SettingsService: SettingsService, private cd: ChangeDetectorRef, private cookies: cookiesService,    public BilletsService: BilletsService, private route: ActivatedRoute, @Inject(PLATFORM_ID) private platformId: Object, private router: Router, private title: Title, private meta: Meta) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        if (isPlatformBrowser(this.platformId)) {
          this.SettingsService.set_open_settings(false)
          this.question_index = 0
          this.loadBilet()

          window.scrollTo({
            top: 0,
            behavior: 'smooth' // или убери behavior для мгновенного скролла
          });
        }
      });

  }

  ngAfterViewInit() {
    this.scrollContainerBillets.nativeElement.scrollLeft = 0
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        if (isPlatformBrowser(this.platformId)) {
          this.scrollBileetsList()
        }
      });

  }

  scrollBileetsList() {
    const element = this.billets.get(this.question_index);
    if (this.scroll_billets.all_billets == false) {
      element?.nativeElement.scrollIntoView({
        behavior: 'smooth',
        inline: 'center',   // start | center | end | nearest
        block: 'nearest'
      });
    }
  }

  ngOnInit(): void {
    this.loadBilet()
  }

  loadBilet() {


    const slug = this.route.snapshot.paramMap.get('slug');
    for (let i =0; i < this.BilletsService.themes_list.length; i++ ) {
      if(this.BilletsService.themes_list[i].url == slug){
        this.check_theme = this.BilletsService.themes_list[i]
        this.theme_index =  i
        break
      }
    }

   for (let i = 0; i < this.BilletsService.my_answer_themes.length; i++) {
     if (this.BilletsService.my_answer_themes[i].index_bilet == this.theme_index) {

       this.my_answer_themes = this.BilletsService.my_answer_themes[i]
       break;
     }
   }




   this.title.setTitle('Вопросы ПДД по теме "'+this.check_theme.title+'" решать онлайн  | ПДД');

   this.meta.updateTag({
     name: 'description',
     content: `Вопросы ПДД по теме "${this.check_theme.title}" Решайте экзаменационные билеты ГИБДД онлайн с ответами и пояснениями. Актуальные вопросы категории АВМ.`
   });

   this.meta.updateTag({
     name: 'keywords',
     content: `${this.check_theme.title} вопросы, пдд, экзамен пдд онлайн, билеты пдд 2026, билеты гибдд, экзаменационные билеты пдд, подготовка к экзамену гибдд, правила дорожного движения`
   });



    for (const q of this.BilletsService.billets_question) {
      this.questionsMap.set(q.id, q);
    }
  }

  onMouseDown(event: MouseEvent, element: HTMLElement) {
    this.scroll_billets.moved = false;
    if (this.scroll_billets.all_billets == false) {
      this.scroll_billets.isDragging = true;
      this.scroll_billets.element = element;

      this.scroll_billets.startX = event.pageX;
      this.scroll_billets.scrollLeft = element.scrollLeft;
    }

  }

  @HostListener('window:mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    if (!this.scroll_billets.isDragging || !this.scroll_billets.element) {
      return;
    }

    const dx = event.clientX - this.scroll_billets.startX;
    if (dx > 15 || dx < -15) {
      this.scroll_billets.moved = true;
    }
    if (this.scroll_billets.moved == true) {

      this.scroll_billets.element.scrollLeft -= dx;

      this.scroll_billets.startX = event.clientX;
    }
  }

  @HostListener('window:mouseup', ['$event'])
  onMouseUp(event: MouseEvent) {
    this.scroll_billets.isDragging = false;
    this.scroll_billets.element = null;
  }


  openBillet(index: number) {
    this.open_explanation = false
    this.question_index = index
    const element = this.billets.get( this.question_index);
    element?.nativeElement.scrollIntoView({
      behavior: 'smooth',
      inline: 'center',   // start | center | end | nearest
      block: 'nearest'
    });
  }

  onScroll(event: Event) {
    const element = event.target as HTMLElement;
    this.scroll_billets.scrollLeft = element.scrollLeft;

    this.scroll_billets.isEnd = element.scrollLeft + element.clientWidth >= element.scrollWidth - 25;

  }

  scrollLeft(element: HTMLElement) {
    element.scrollBy({
      left: -(element.clientWidth / 2),
      behavior: 'smooth'
    });
  }

  scrollRight(element: HTMLElement) {
    element.scrollBy({
      left: (element.clientWidth / 2),
      behavior: 'smooth'
    });
  }

  vueAllBillets() {
    this.scroll_billets.all_billets = !this.scroll_billets.all_billets
    if (this.scroll_billets.all_billet == false) {

      window.scrollTo({
        top: 0,
        behavior: 'smooth' // или убери behavior для мгновенного скролла
      });

    }

  }

  chekAnswer(question_index: number, answer_index: number) {


    const question = this.BilletsService.billets_question[question_index];

    if (!question?.bilet_theme?.select) {

      let answer = this.BilletsService.billets_question[question_index].answers[answer_index].correct
      let index = -1

      for (let i = 0; i < this.BilletsService.my_answer_themes.length; i++) {
        if (this.BilletsService.my_answer_themes[i].index_bilet == this.theme_index) {
          index = i
          this.BilletsService.my_answer_themes[i].list_question.push(
            {
              index_question: question_index,
              index_answer: answer_index
            }
          )
          this.my_answer_themes = this.BilletsService.my_answer_themes[i]
          break;
        }
      }
      if (index < 0) {
        let new_answer = {
          index_bilet: this.theme_index,
          list_question: [
            {
              index_question: question_index,
              index_answer: answer_index
            }
          ]
        }
        this.BilletsService.my_answer_themes.push(new_answer)

        this.my_answer_themes = new_answer

      }


      this.BilletsService.billets_question[question_index].bilet_theme = {select: true, status: answer}


      for (let i = 0; i < this.BilletsService.billets_question[question_index].answers.length; i++) {
        if (i == answer_index) {
          this.BilletsService.billets_question[question_index].answers[i].theme_select = true
        } else {
          this.BilletsService.billets_question[question_index].answers[i].theme_select = false
        }
      }


      if ((this.SettingsService.showHintAfterWrongAnswer && answer == false) || (this.SettingsService.showHintAfterCorrectAnswer && answer == true)) {
        this.open_explanation = true
      }
      if (!this.SettingsService.showResultsOnlyAfterCompletion) {
        if (this.SettingsService.autoNextQuestionAfterCorrectAnswer && answer == true) {
          this.nextQuiz()
        }

        if (this.SettingsService.autoNextQuestionAfterWrongAnswer && answer == false) {
          this.nextQuiz()
        }
      } else {
        this.nextQuiz()
      }

    }

  }

  nextQuiz() {
    if(this.question_index < this.check_theme.questions_list.length -1){
      this.openBillet(this.question_index + 1)
    }

  }

  count_error() {
    let count = 0;
    for (let j = 0; j < this.check_theme.questions_list.length; j++) {
      for (let i = 0; i < this.BilletsService.billets_question.length; i++) {
        if (!this.BilletsService.billets_question[i].bilet_theme?.status && this.check_theme.questions_list[j] == this.BilletsService.billets_question[i].id) {
          count++
        }
      }
    }

    return count
  }

  count_success() {
    let count = 0;
    for (let j = 0; j < this.check_theme.questions_list.length; j++) {
      for (let i = 0; i < this.BilletsService.billets_question.length; i++) {
        if (this.BilletsService.billets_question[i].bilet_theme?.status && this.check_theme.questions_list[j] == this.BilletsService.billets_question[i].id) {
          count++
        }
      }
    }

    return count
  }

}
